import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/StudioLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
const SocialMediaPosts = lazy(() => import('./pages/StudioSocial'));
const ArticleCreation = lazy(() => import('./pages/ArticleCreation'));
const ArticleEdit = lazy(() => import('./pages/ArticleEdit'));
const StudioLibrary = lazy(() => import('./pages/StudioLibrary'));
const AuthPage = lazy(() => import('./pages/AuthPage'));
import StudioDesk from './pages/StudioDesk';
const StudioAutomation = lazy(() => import('./pages/StudioAutomation'));
const StudioReview = lazy(() => import('./pages/StudioReview'));
const ImageReviewTest = lazy(() => import('./pages/ImageReviewTest'));
const Images = lazy(() => import('./pages/Images'));
const PromptReview = lazy(() => import('./pages/PromptReview'));
const QuoteGuideDetail = lazy(() => import('./pages/QuoteGuideDetail'));
const QuoteGuideSocial = lazy(() => import('./pages/QuoteGuideSocial'));
const QuoteGuidesList = lazy(() => import('./pages/QuoteGuidesList'));
const QuoteGuideScratchCreate = lazy(() => import('./pages/QuoteGuideScratchCreate'));
const Quotes = lazy(() => import('./pages/Quotes'));
const QuotesWorkspace = lazy(() => import('./pages/QuotesWorkspace'));
const QuoteStudio = lazy(() => import('./pages/QuoteStudio'));
const QuoteStudioReview = lazy(() => import('./pages/QuoteStudioReview'));
const Settings = lazy(() => import('./pages/Settings'));
const Specialized = lazy(() => import('./pages/Specialized'));

function App() {
  return (
    <Suspense fallback={<p role="status" className="p-8">Opening workspace…</p>}><Routes>
      <Route path="/auth" element={<AuthPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<StudioDesk />} />
                <Route path="/editorial" element={<StudioDesk />} />
                <Route path="/calendar" element={<StudioDesk calendar />} />
                <Route path="/automation" element={<StudioAutomation />} />
                <Route path="/review/:articleId" element={<StudioReview />} />
                <Route path="/create" element={<ArticleCreation />} />
                <Route path="/articles" element={<StudioLibrary />} />
                <Route
                  path="/articles/:articleId/edit"
                  element={<ArticleEdit />}
                />
                <Route
                  path="/articles/:articleId/social"
                  element={<SocialMediaPosts />}
                />
                <Route
                  path="/articles/:articleId/prompts"
                  element={<PromptReview />}
                />
                <Route path="/settings" element={<Settings />} />
                <Route path="/images" element={<Images />} />
                <Route path="/quotes" element={<QuotesWorkspace />} />
                <Route path="/quote-studio" element={<QuoteStudio />} />
                <Route path="/quote-studio/:runId" element={<QuoteStudioReview />} />
                <Route path="/quotes/guides" element={<QuoteGuidesList />} />
                <Route
                  path="/quotes/guides/generate"
                  element={<QuoteGuideScratchCreate />}
                />
                <Route
                  path="/quotes/guides/:guideId"
                  element={<QuoteGuideDetail />}
                />
                <Route
                  path="/quotes/guides/:guideId/social"
                  element={<QuoteGuideSocial />}
                />
                <Route path="/quotes/import" element={<Quotes />} />
                <Route path="/specialized" element={<Specialized />} />
                <Route
                  path="/test-image-review"
                  element={<ImageReviewTest />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes></Suspense>
  );
}

export default App;
